<template>
  <div class="access-denied">
    <h1>403 - Нет доступа</h1>
    <p>У вас недостаточно прав для доступа к этому ресурсу.</p>
    <router-link to="/">Вернуться на главную страницу</router-link>
  </div>
</template>

<script>
export default {
  name: 'AccessDenied',
};
</script>

<style scoped>
.access-denied {
  text-align: center;
  margin-top: 50px;
}
</style>
